const WireframingContent = {
	meta: "Wireframing",
	title: "Rapid low resolution wireframing",
	paras: [
		"The on-site search function was below user expectation on so many levels. The strategy was to achieve regular, incremental improvements to immediately start improving the experience.",
		"I first tackled the search results card, reviewing customer questions and competitor solutions. The information architecture would be crucial to success. Also, for the first time, a component on the site would be fully responsive - optimised for all device ranges.",
	],
	img01alt: "Whiteboard with stickies",
	img01caption: "Team observations from lab testing cruise customers",
	img02alt: "Hotjar heat map",
	img02caption: "Utilising user behavior software like Hotjar",
	table: {
		th01: "New to cruise",
		th02: "Regular cruisers",
		list01: [
			"What's it going to be like onboard?",
			"How do the travel logistics work?",
			"Will this cruise be right for me?",
		],
		list02: [
			"What offers are there?",
			"What destination is right for me?",
			"What sets a cruise apart?",
		],
		caption: "Top questions customers have, gathered from targeted surveys",
	},
};

export default WireframingContent;
